import { render, staticRenderFns } from "./PWS02G04.vue?vue&type=template&id=03972fcc&scoped=true"
import script from "./PWS02G04.vue?vue&type=script&lang=js"
export * from "./PWS02G04.vue?vue&type=script&lang=js"
import style0 from "./PWS02G04.vue?vue&type=style&index=0&id=03972fcc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03972fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03972fcc')) {
      api.createRecord('03972fcc', component.options)
    } else {
      api.reload('03972fcc', component.options)
    }
    module.hot.accept("./PWS02G04.vue?vue&type=template&id=03972fcc&scoped=true", function () {
      api.rerender('03972fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pws/PWS02G04.vue"
export default component.exports